import toast from "react-hot-toast";

interface ToastOptions {
  status: "success" | "error" | "warning" | "info";
  title: string;
  description?: string;
  duration?: number;
  position?: "top" | "bottom" | "top-right" | "top-left" | "bottom-right" | "bottom-left";
}

export const showToast = ({
  status,
  title,
  description,
  duration = 3000,
}: ToastOptions) => {
  const message = description ? `${title}\n${description}` : title;

  switch (status) {
    case "success":
      toast.success(message, { duration });
      break;
    case "error":
      toast.error(message, { duration });
      break;
    case "warning":
      toast(message, {
        duration,
        icon: "⚠️",
        style: { background: "#fffbeb", color: "#92400e", border: "1px solid #fcd34d" },
      });
      break;
    case "info":
      toast(message, {
        duration,
        icon: "ℹ️",
        style: { background: "#eff6ff", color: "#1e40af", border: "1px solid #bfdbfe" },
      });
      break;
    default:
      toast(message, { duration });
      break;
  }
};
